import React from "react";

const ReviewPage = ({ questions, answers, onSelect, onExit }) => {
  return (
    <div className="min-h-screen bg-white px-6 py-8">
      <div className="flex justify-between items-center mb-6 border-b pb-4">
        <h2 className="text-xl font-bold text-gray-800">مرور پاسخ‌ها</h2>
        <button
          onClick={onExit}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm"
        >
          خروج از مرور
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {questions.map((q, i) => (
          <button
            key={q._id}
            onClick={() => onSelect(i)}
            className={`p-3 text-sm rounded-md border text-center transition-all ${
              answers[i] !== null
                ? "bg-green-100 border-green-400 text-green-800 font-medium"
                : "bg-gray-100 text-gray-600 border-gray-300"
            }`}
          >
            سوال {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReviewPage;
